import React from 'react';
import { Helmet } from 'react-helmet';
import Header from './Header';
import Footer from './Footer';

const Contact = () => {
  return (
    <div>
      <Helmet>
        <title>Contact Holy See Bright Academy – Admissions Office, Phone, Email</title>
        <meta 
          name="description" 
          content="Contact Holy See Bright Academy: +2348145406055, +2348067237920. Visit our campus in Karu, Nasarawa State. Admissions inquiries, school tours, and information." 
        />
        <meta name="keywords" content="contact Holy See Bright Academy, school phone number, admission inquiry, campus visit, Karu Nasarawa, school address Nigeria" />
        <link rel="canonical" href="https://holyseebright.com/contact" />
      </Helmet>
      
      <Header />
      <main style={{ minHeight: '70vh', padding: '40px 20px' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <h1>Contact Holy See Bright Academy</h1>
          
          <div style={{ background: '#f8f9fa', padding: '30px', borderRadius: '10px', margin: '30px 0' }}>
            <h2>📍 Campus Address</h2>
            <p><strong>Main Campus:</strong><br />
            No. 1 Emmanuel Street, Jeun Amawa<br />
            Karu Local Government Area<br />
            Nasarawa State, Nigeria</p>
          </div>
          
          <div style={{ background: '#f8f9fa', padding: '30px', borderRadius: '10px', margin: '30px 0' }}>
            <h2>📞 Contact Information</h2>
            <p><strong>Principal's Office:</strong> +2348145406055</p>
            <p><strong>Admissions Office:</strong> +2348067237920</p>
            <p><strong>Email:</strong> info@holyseebright.com</p>
            <p><strong>School Hours:</strong> Monday - Friday: 7:30 AM - 4:00 PM</p>
          </div>
          
          <div style={{ background: '#f8f9fa', padding: '30px', borderRadius: '10px', margin: '30px 0' }}>
            <h2>📋 Admissions Office</h2>
            <p>For admission inquiries, please visit during office hours or call our admissions line.</p>
            <p><strong>Admission Requirements:</strong></p>
            <ul>
              <li>Completed application form</li>
              <li>Birth certificate</li>
              <li>Previous school results</li>
              <li>Passport photographs</li>
            </ul>
          </div>
          
          <div style={{ background: '#f8f9fa', padding: '30px', borderRadius: '10px', margin: '30px 0' }}>
            <h2>🗺️ How to Find Us</h2>
            <p>From Abuja: Take the Nyanya-Karu expressway to Karu. Turn at Jeun Junction and follow Emmanuel Street.</p>
            <p><em>GPS Coordinates: Available upon request</em></p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Contact;